export const historiesLoadSuccess = (histories) => {
    return {
        type : 'HISTORIES_LOAD_SUCCESS',
        payload : {
            histories
        }
    }
}
export const historiesLoadFail = () => {
    return {
        type : 'HISTORIES_LOAD_FAIL'
    }
}

export const loadHistories = () => {
   return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const historiesRef = firebase.ref().child('histories/');

        historiesRef.orderByChild('year').once('value', (snapshot)=> {
            let histories = []; 
            snapshot.forEach(history => {
                histories.push({
                    id : history.key,
                    ...history.val()
                });
            })
            dispatch(historiesLoadSuccess(histories));
        })
    }
}



// WEBPACK FOOTER //
// ./src/pages/About/actions/aboutActions.js